import React from 'react';

export default function UserSettings() {
  return <div>Settings</div>;
}
